<template>
    <vx-card class="min-h-400">
        <vs-table
            no-data-text=""
            stripe
            :data="receivers"
        >
            <template slot="header">
                <div class="w-full flex">
                  <vs-button
                    class="mr-2"
                    icon-pack="feather"
                    icon="icon-download"
                    color="dark"
                    @click="exportReceivers"
                  >
                    Экспорт
                  </vs-button>
                  <vs-button
                    class="download-button"
                    icon-pack="feather"
                    icon="icon-upload"
                    color="dark"
                    :disabled="task.status !== 'draft'"
                    @click="importReceivers"
                  >
                    Импорт
                  </vs-button>
                </div>
                <input ref="fileInput" accept="text/csv" class="input" type="file" @change="onUploadFile" >
            </template>

            <template slot="thead" v-if="receiversColumnsHeaderNames">

                <vs-th v-for="column in receiversColumnsHeaderNames" sort-key="column" :key="column">
                    <div class="flex justify-start w-full">
                        {{ column }}
                    </div>
                </vs-th>

            </template>

            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td v-for="(item, key) in getRow(data[indextr])" :key="key" class="text-left whitespace-no-wrap">
                        <div v-if="typeof item === 'string'" class="flex justify-start">
                            {{ item }}
                        </div>
                        <vs-chip v-else :color="getStatusColor(item)">{{ getStatus(item) }}</vs-chip>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <div
          v-if="pagination"
          :class="{'hidden': pagination.total <= 1}"
        >
          <vs-pagination
            :total="total"
            :value="page"
            :max="max"
            @input="nextPage"
          />
        </div>
        <div v-if="receivers.length === 0">
          <h6 class="fw-bold text-center mt-1 mb-3">Получатели еще не импортированы</h6>
          <ol>
            <li class="text-center">
              1. Скачайте csv документ, нажав кнопку 'Экспорт'
            </li>
            <li class="text-center">
              2. Заполните все необходимые колонки и строки
            </li>
            <li class="text-center">
              3. Загрузите csv документ, нажав кнопку 'Импорт'
            </li>
          </ol>
        </div>

    </vx-card>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState, mapActions } from 'vuex'
import downloadFile from '@/mixins/downloadFile'
import BulkDeliveryHelpers from '@/pages/bulk-delivery/mixins/helpers'

export default {
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  mixins: [downloadFile, BulkDeliveryHelpers],
  computed: {
    ...mapGetters(['authUserCompany']),
    ...mapGetters('Receivers', ['total', 'max', 'page']),
    ...mapState('Receivers', {
      receivers: state => state.items,
      pagination: state => state.pagination
    }),
    receiversColumns () {
      const head = this.receivers[0]

      if (!head) {
        return []
      }

      return [{ key: 'status', value: 'Статус' }, ...Object.keys(head.fields).map((key) => ({ key, value: key }))]
    },
    receiversColumnsHeaderNames () {
      return this.receiversColumns.map(({ value }) => value)
    },
    receiversColumnsHeaderKeys () {
      return this.receiversColumns.map(({ key }) => key)
    }
  },
  methods: {
    ...mapActions('Receivers', ['nextPage', 'fetchItems']),
    getValue (data, key) {
      const value = data[key] || data.fields[key]

      if (key === 'status') {
        return { status: value }
      }

      return value
    },
    getRow (data) {
      return this.receiversColumnsHeaderKeys.map((key) => this.getValue(data, key))
    },
    async exportReceivers () {
      const response = await this.$api.BulkDelivery.exportReceivers(this.authUserCompany.slug, this.task.slug)

      if (response) {
        const timezone = this.authUserCompany.timezone || 0
        const timestamp = moment.utc(new Date()).utcOffset(timezone).valueOf()
        this.downloadFile(response, `export_receivers_${timestamp}.csv`, 'text/csv')
      }
    },
    importReceivers () {
      this.$refs.fileInput.click()
    },
    async onUploadFile () {
      try {
        const file = this.$refs.fileInput.files[0]
        const formData = new FormData()
        formData.append('import', file)
        const { status } = await this.$api.BulkDelivery.importReceivers(this.authUserCompany.slug, this.task.slug, formData)
        if (status === 'success') {
          this.$vs.notify({
            color: 'success',
            title: 'Успешно',
            text: 'Получатели успешно загружены'
          })

          const [{ data: task }] = await Promise.all([
            this.$api.BulkDelivery.getTask(this.authUserCompany.slug, this.task.slug).catch((e) => console.error(e)),
            this.fetchItems(this.task.slug).catch((e) => console.error(e))
          ])
          this.$emit('changeTask', task)
          this.$refs.fileInput.value = ''
          return
        }

        this.$vs.notify({
          color: 'danger',
          title: 'Ошибка',
          text: 'Ошибка при загрузке получателей'
        })
      } catch (e) {
        console.error(e)
        this.$vs.notify({
          color: 'danger',
          title: 'Ошибка',
          text: 'Ошибка при загрузке получателей'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    left: -999999px;
  }
</style>
